export default __webpack_public_path__ + "static/python-63580e54e2e501e3d07de0c07a3a8c3c.png";